import { Analytics } from '@segment/analytics-next';
import mixpanel from 'mixpanel-browser';

import { marketingConfig } from '../config/marketing';
import { FacebookPixel } from '../services/facebook';

let analytics: Analytics | null = null;

export const initializeMarketing = () => {
  try {
    // Initialize Segment
    if (marketingConfig.segment.writeKey) {
      analytics = new Analytics({
        writeKey: marketingConfig.segment.writeKey,
      });
    }

    // Initialize Mixpanel
    if (marketingConfig.mixpanel.token) {
      mixpanel.init(marketingConfig.mixpanel.token);
    }

    // Initialize Facebook Pixel
    if (marketingConfig.facebook.pixelId) {
      FacebookPixel.init(marketingConfig.facebook.pixelId);
    }

    // console.log('Marketing integrations initialized successfully');
  } catch {
    // console.error('Error initializing marketing integrations');
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  try {
    // Track event in Segment
    if (analytics) {
      analytics.track(eventName, properties);
    }

    // Track event in Mixpanel
    if (marketingConfig.mixpanel.token) {
      mixpanel.track(eventName, properties);
    }

    // Track event in Facebook Pixel
    if (marketingConfig.facebook.pixelId) {
      FacebookPixel.trackEvent(eventName, properties);
    }
  } catch {
    // console.error('Error tracking event:', eventName);
  }
};

export const identifyUser = (userId: string, traits?: Record<string, unknown>) => {
  try {
    // Identify user in Segment
    if (analytics) {
      analytics.identify(userId, traits);
    }

    // Identify user in Mixpanel
    if (marketingConfig.mixpanel.token) {
      mixpanel.identify(userId);
      if (traits) {
        mixpanel.people.set(traits);
      }
    }
  } catch {
    // console.error('Error identifying user:', userId);
  }
};

export const trackPageView = (pageName: string, properties?: Record<string, unknown>) => {
  try {
    // Track page view in Segment
    if (analytics) {
      analytics.page(pageName, properties);
    }

    // Track page view in Mixpanel
    if (marketingConfig.mixpanel.token) {
      mixpanel.track('Page View', { page: pageName, ...properties });
    }

    // Track page view in Facebook Pixel
    if (marketingConfig.facebook.pixelId) {
      FacebookPixel.pageView();
    }
  } catch {
    // console.error('Error tracking page view:', pageName);
  }
};
